import './Container.scss';
const Container = ({ children }: { children: React.ReactNode }) => {
  return <div className="kodiraonica-container">{children}</div>;
};

export default Container;
